
export default function BenefitsSection() {
  const benefits = [
    {
      title: '新商品体験',
      description: '市場に出る前の新商品や改良品を、他の方より早く体験していただけます。最新のトレンドに触れる機会をご提供します。',
      image: 'https://public.readdy.ai/ai/img_res/47831e65b0e141d1191b2834c9b0b009.jpg',
      bgColor: 'bg-blue-50'
    },
    {
      title: '適正な謝礼',
      description: 'フィードバックご提供後、案件に応じた適正な謝礼をお支払いいたします。金額は事前にご案内し、透明性を保っています。',
      image: 'https://readdy.ai/api/search-image?query=Money%20reward%20with%20coins%20and%20bills%2C%20payment%20and%20compensation%20concept%20illustration%20with%20green%20and%20emerald%20colors%2C%20modern%20flat%20design%20style%2C%20white%20simple%20background&width=400&height=400&seq=benefit2&orientation=squarish',
      bgColor: 'bg-green-50'
    },
    {
      title: '商品開発への貢献',
      description: 'あなたのご意見が商品の改善に直接活かされます。より良い商品づくりに参加し、社会に貢献する機会です。',
      image: 'https://readdy.ai/api/search-image?query=Product%20development%20with%20lightbulb%20and%20innovation%20symbols%2C%20creative%20ideas%20and%20improvement%20concept%20illustration%20with%20purple%20and%20violet%20colors%2C%20modern%20flat%20design%20style%2C%20white%20simple%20background&width=400&height=400&seq=benefit3&orientation=squarish',
      bgColor: 'bg-purple-50'
    },
    {
      title: '柔軟なスケジュール',
      description: 'ご自身のペースで商品をお試しいただけます。無理のないスケジュールで、空いた時間を有効活用できます。',
      image: 'https://readdy.ai/api/search-image?query=Flexible%20time%20management%20with%20clock%20and%20calendar%2C%20work-life%20balance%20concept%20illustration%20with%20orange%20and%20amber%20colors%2C%20modern%20flat%20design%20style%2C%20white%20simple%20background&width=400&height=400&seq=benefit4&orientation=squarish',
      bgColor: 'bg-orange-50'
    },
    {
      title: '安心・安全',
      description: '個人情報保護を徹底し、SSL暗号化通信で安全にやり取りします。長年の運営実績で培った信頼性をお約束します。',
      image: 'https://readdy.ai/api/search-image?query=Security%20shield%20with%20lock%20and%20checkmark%2C%20data%20protection%20and%20safety%20concept%20illustration%20with%20indigo%20and%20blue%20colors%2C%20modern%20flat%20design%20style%2C%20white%20simple%20background&width=400&height=400&seq=benefit5&orientation=squarish',
      bgColor: 'bg-indigo-50'
    },
    {
      title: '多様な商品カテゴリ',
      description: '美容・健康・家電・食品など、幅広いジャンルの商品をご用意。あなたの興味に合った案件をご紹介いたします。',
      image: 'https://readdy.ai/api/search-image?query=Diverse%20product%20categories%20with%20beauty%2C%20electronics%2C%20food%20items%2C%20variety%20and%20choice%20concept%20illustration%20with%20pink%20and%20rose%20colors%2C%20modern%20flat%20design%20style%2C%20white%20simple%20background&width=400&height=400&seq=benefit6&orientation=squarish',
      bgColor: 'bg-pink-50'
    }
  ];

  return (
    <section id="reward" className="py-12 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            モニター参加のメリット
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
            商品体験プログラムにご参加いただくことで得られる価値をご紹介します
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className={`${benefit.bgColor} rounded-2xl p-6 sm:p-8 text-center hover:shadow-lg transition-shadow`}>
              <img 
                src={benefit.image} 
                alt={benefit.title}
                className="w-48 h-48 object-cover rounded-xl mx-auto mb-4 sm:mb-6"
              />
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4">{benefit.title}</h3>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 sm:mt-16 bg-gray-50 rounded-2xl p-4 sm:p-8">
          <div className="text-center">
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
              <i className="ri-information-line mr-2 text-blue-600"></i>
              重要なお知らせ
            </h3>
            <div className="text-left max-w-4xl mx-auto space-y-3 sm:space-y-4 text-sm sm:text-base text-gray-700">
              <p>
                <strong>・商品体験について：</strong>
                提供される商品は、商品開発・改善のためのフィードバック収集を目的としています。
              </p>
              <p>
                <strong>・フィードバック提供について：</strong>
                商品改善のための率直なご意見・ご感想をお聞かせください。
                特定のプラットフォームでの投稿を前提とするものではありません。
              </p>
              <p>
                <strong>・謝礼について：</strong>
                フィードバック提供完了後、案件に応じた適正な謝礼をお支払いいたします。
                金額・支払方法は事前にご案内いたします。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
